<template>
  <section class="application w-12r m-a p-r ov-h">
    <h2 class="ta-c" :class="appDesc ? '' : 'mb-32'">{{ appH2 }}</h2>
    <div class="desc-html" v-if="isHtml" v-html="$t(appDesc)"></div>
    <div class="desc m-a ta-c c-666" v-if="appDesc && !isHtml">
      <p class="">
        {{ appDesc }}
      </p>
    </div>
    <ul class="d-f jc-sb fw-w ai-fs">
      <li class="p-r" v-for="(item, index) in applicationData" :key="index">
        <img width="100%" height="100%" class="lazy-image" v-lazy="item.imgUrl" :alt="$t(item.imgDesc)" />
        <strong class="bottom-desc d-b p-a" v-html="$t(item.imgDesc)"></strong>
      </li>
    </ul>
  </section>
</template>

<script>
  import { gsap } from 'gsap'
  export default {
    props: {
      applicationData: {
        type: Array,
        default: () => []
      },
      appH2: {
        type: String,
        default: ''
      },
      appDesc: {
        type: String,
        default: ''
      },
      isHtml: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {}
    },
    created() {},
    mounted() {
      // eslint-disable-next-line nuxt/no-env-in-hooks
      if (process.browser) {
        this.apllicationAnimate()
      }
    },
    methods: {
      apllicationAnimate() {
        gsap.from('.application li', {
          scrollTrigger: {
            trigger: '.application',
            start: '35% 70%',
            end: '35% 70%',
            scrub: 5
            // markers: true,
          },
          stagger: 0.3,
          duration: 1,
          y: '100%',
          opacity: 0
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .application {
    padding-top: 1.6rem;
  }
  .application h2 {
    font-size: 0.48rem;
    color: #333;
    font-weight: 700;
  }

  .application .desc {
    width: 8.96rem;
    padding: 0.24rem 0 0.32rem 0;
    text-align: center;
  }
  .desc-html {
    text-align: center;
    padding: 0.24rem 0 0.32rem 0;
    margin: 0 auto;
    font-size: 0.18rem;
    color: #666;
  }
  .application li {
    width: 2.88rem;
    height: 5.1rem;
  }
  .application li strong {
    font-weight: 500;
    line-height: 1.2;
  }
  .application .bottom-desc {
    bottom: 0.32rem;
    font-size: 0.2rem;
    width: 100%;
    text-align: center;
    color: #fff;
    font-weight: 500;
  }
</style>
